import { Lock } from "lucide-react";

export const EmBreve = ({ children, label = "Em breve" }) => (
  <div data-testid="em-breve-card" className="relative rounded-xl overflow-hidden cursor-not-allowed select-none">
    <div className="grayscale opacity-60 pointer-events-none" aria-hidden="true">{children}</div>
    <div className="absolute inset-0 backdrop-blur-[2px] bg-white/60 flex flex-col items-center justify-center gap-2">
      <div className="w-10 h-10 rounded-full bg-slate-900 flex items-center justify-center">
        <Lock className="w-4 h-4 text-amber-400" />
      </div>
      <span className="text-xs uppercase tracking-[0.2em] font-bold text-slate-900">{label}</span>
    </div>
  </div>
);
